import type { PageProps } from 'gatsby';
import React from 'react';

import BigCircle from '@components/BigCircle';

import AdminManagement from '@views/Admin/Management';
import { Drilldown } from '@views/Admin/Management/Accounts';

export default function AdminAccountDrilldownPage({ params }: PageProps) {
  const { account_id } = params;

  return (
    <AdminManagement.Layout maxContentWidth="md">
      <BigCircle />
      {account_id && <Drilldown account_id={account_id} />}
    </AdminManagement.Layout>
  );
}
